var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Button, Checkbox } from '@philips-internal/oswald-ui-components/lib/components';
import { ButtonType, Size } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { array, bool, eventListener, object, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import ResultTermCardAPI from './result-term-service-api';
import './result-term-service.css';
let ResultTermService = class ResultTermService extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            check: false,
        };
        this.getTerm = () => {
            const { data } = this.props;
            if (Array.isArray(data) && data.length > 0) {
                return data[0]?.termDescription ?? '';
            }
            const termData = data;
            return termData?.termDescription ?? '';
        };
        this.submitTermUse = () => {
            const { onSubmitTermUse } = this.props;
            if (isFunction(onSubmitTermUse)) {
                onSubmitTermUse(new ClickEvent({
                    value: {
                        onSubmitTermUse,
                    },
                }));
            }
        };
    }
    onCheck() {
        this.setState((prevState) => ({ check: !prevState.check }));
    }
    render() {
        const { showCheck, enabled } = this.props;
        return (React.createElement("div", { className: "c-term-service" },
            React.createElement("div", { className: "c-result-term-service", dangerouslySetInnerHTML: { __html: this.getTerm() } }),
            showCheck &&
                (React.createElement("div", { className: "c-term-service__check" },
                    React.createElement("div", { className: "c-term-service__check-checkbox" },
                        React.createElement(Checkbox, { label: `${MessageService.translate('newaccount.text.agree.with')} ${MessageService.translate(this.props.term)}`, onChange: () => this.onCheck(), value: this.state.check, enabled: enabled, name: 'checkbox-terms', uuid: '1fce4f18-835c-11ec-a8a3-0242ac120002' })),
                    React.createElement("div", { className: "c-term-service__check-button" },
                        React.createElement(Button, { size: Size.LARGE, value: MessageService.translate('approval.confirm'), type: ButtonType.SUBMIT, enabled: this.state.check, onClick: () => this.submitTermUse() }))))));
    }
};
ResultTermService.DefaultProps = {
    showCheck: false,
};
ResultTermService.propTypes = {
    term: string,
    data: oneOfType([object, array]),
    enabled: bool,
    onSubmitTermUse: eventListener,
    showCheck: bool,
};
ResultTermService = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ResultTermCardAPI })
], ResultTermService);
export default ResultTermService;
//# sourceMappingURL=result-term-service.js.map